// Keep product typography deterministic without downloading or naming a
// platform-proprietary web font. Apple devices resolve the system entries to
// their native UI face; other platforms use their own familiar system face.
export const APP_UI_FONT_STACK = [
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  'Helvetica',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(', ');

// Monospace is reserved for content where character alignment carries
// meaning: technical identifiers, source snippets, and fixed-format exports.
export const APP_MONO_FONT_STACK = [
  'ui-monospace',
  'SFMono-Regular',
  'Menlo',
  'Monaco',
  'Consolas',
  '"Liberation Mono"',
  'monospace',
].join(', ');
